/**
 * Listing Filter helper
 * 
 */
'use strict';

import { PathFactoryLinkUTMs } from './components/pathfactory-link-utms';

export class FilterHelper
{
  constructor()
  {
    this.component_id = '';

    this.config       = {

      /**
       * Ajax request action name
       * 
       * @type 
       */
      action: '',

      /**
       * If true, will dynamically add chip to chip container
       * 
       * @type Boolean
       */
      add_chip_on_active: false,

      /**
       * Author ID
       * 
       * @type Number
       */
      author_id: 0,

      /**
       * Default chips taxonomy
       * 
       * @type String
       */
      chips_taxonomy: 'sd-tax-sysdig-topic',

      /**
       * Component ID
       * 
       * @type String
       */
      component_id: '',

      /**
       * Is Webinar toggle
       *
       * If true, will make separate requests for upcoming and on-demand content 
       * 
       * @type Boolean
       */
      is_webinar: false,

      /**
       * Items per page
       * 
       * @type Number
       */
      items_per_page: 12,

      /**
       * Items per row
       * 
       * @type Number
       */
      items_per_row: 3,

      /**
       * Order by
       * 
       * @type String
       */
      order_by: '',

      /**
       * Page number
       * 
       * @type Number
       */
      paged: 1,

      /**
       * Post types
       * 
       * @type Array
       */
      post_types: [],

      /**
       * If true, will remove chip on deactivation. Otherwise will only remove active state
       * 
       * @type Boolean
       */
      remove_chip_on_deactivate: false,

      /**
       * Search string
       * 
       * @type String
       */
      search_term: '',

      /**
       * Taxonomy terms
       * 
       * @type Object
       */
      terms: {},

      /**
       * Scroll top offset, in pixels
       * 
       * @type Number
       */
      top_offset: 500,

      /**
       * Current view
       * 
       * @type String grid|list
       */
      view: 'grid',

      callback: ''
    };

    this.target       = {

      /**
       * Target container element to update with ajax response
       * 
       * @type jQuery
       */
      target_container: '',

      /**
       * Element to scroll back to top
       * 
       * @type String
       */
      top: '',

      /**
       * Upcoming and On-Demand Webinar elements
       * 
       * @type jQuery
       */
      webinar_upcoming: '',
      webinar_on_demand: ''
    };
  }

  /**
   * Init config
   *
   * @param object config
   */
  init_config( config = {} )
  {
    this.config         = {...this.config, ...config};
    this.default_config = structuredClone( this.config );
    this.component_id   = '#' + config.component_id;
  }

  /**
   * Init target
   * 
   * @param object config
   */
  init_target( config = {} )
  {
    this.target = {...this.target, ...config};

    this.target.chips                 = $(this.component_id + ' .c-chips a.chip:not(.default)');
    this.target.chips_all             = $(this.component_id + ' .c-chips a.chip.all');
    this.target.dropdown_content_type = $(this.component_id + ' .filter--dropdown input[type=checkbox].filter--dropdown-content-type');
    this.target.dropdown_sort         = $(this.component_id + ' .filter--dropdown input[type=checkbox].filter--dropdown-sort');
    this.target.dropdown_taxonomy     = $(this.component_id + ' .filter--dropdown input[type=checkbox].filter--dropdown-taxonomy-term');
    this.target.search                = $(this.component_id + ' input[type=search].filter--search');
    this.target.result_text           = $(this.component_id + ' .filter--search-wrapper-text span');
    this.target.reset                 = $(this.component_id + ' .filter--reset');
    this.target.view_toggle           = $(this.component_id + ' .filter--view-toggle');
  }

  /**
   * Init
   */
  init()
  {
    this.init_chips();
    this.init_dropdown_sort();
    this.init_dropdown_terms();
    this.init_dropdown_types();
    this.init_pagination();
    this.init_search();
    this.init_view_toggle();
  }

  /**
   * Add callback option after ajax request
   *
   * @param func cb
   */
  init_callback( cb )
  {
    if ( cb ) 
    {
      this.callback = cb;
    }
  }

  /**
   * Back to top
   * 
   */
  back_to_top()
  {
    scroll({
      top:      this.target.top.offset().top - this.config.top_offset,
      behavior: 'smooth'
    });
  }

  /**
   * Debounce
   *
   * @link https://davidwalsh.name/javascript-debounce-function
   * 
   * @param  function func
   * @param  integer  wait
   * @param  boolean  immediate
   * @return function
   */
  debounce( func, wait, immediate )
  {
    var timeout;

    return function()
    {
        var context = this, args = arguments;
        var later   = function()
        {
            timeout = null;

            if ( ! immediate ) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if ( callNow ) func.apply(context, args);
    };
  }

  /**
   * Init chips
   * 
   */
  init_chips()
  {
    let _self = this;

    // Reset
    $('body').on('click', this.component_id + ' .filter--reset', function( e )
    {
      e.preventDefault();

      _self.reset();
    });

    // Chips click
    $('body').on('click', this.component_id + ' .c-chips a.chip', function( e )
    {
      e.preventDefault();

      // Show all
      if ( $(this).hasClass('all') )
      {
        if ( ! $(this).hasClass('active') )
        {
          $(_self.component_id + ' a.chip:not(.all)').removeClass('active');

          $(this).addClass('active');

          delete _self.config.terms[ _self.config.chips_taxonomy ];

          _self.config.paged = 1;

          //_self.show_reset();
          _self.make_ajax_request();
        }
      }
      else
      {
        /**
         * Prevent deactivating a default chip on Taxonomy pages
         * 
         */
        if ( ! $(this).hasClass('default') )
        { 
          // Remove terms
          if ( $(this).hasClass('active') )
          {
            _self.remove_term( $(this) );
          }

          // Add term
          else
          {
            _self.add_term( $(this) );
          }

          $(this).toggleClass('active');
        }
      }
    });
  }

  /**
   * Init dropdown sort
   * 
   */
  init_dropdown_sort()
  {
    let _self = this;

    this.target.dropdown_sort.on('change', function( e )
    {
      _self.config.order_by = '';

      // Keep dropdown open
      $(this).closest( '.dropdown-menu' ).addClass('show');
      $(this).closest( '.dropdown' ).addClass('show');

      if ( $(this).is(':checked') )
      {
        // If newest, disable oldest
        if ( $(this).val() == 'newest' )
        {
          _self.target.dropdown_sort.filter(function()
          {
            return ( $(this).val() == 'oldest' );
          }).attr('disabled', 'disabled');
        }

        // If oldest, disable newest
        else if ( $(this).val() == 'oldest' )
        {
          _self.target.dropdown_sort.filter(function()
          {
            return ( $(this).val() == 'newest' );
          }).attr('disabled', 'disabled');
        }

        _self.show_reset();
      }
      else
      {
        if ( $(this).val() == 'newest' || $(this).val() == 'oldest' )
        {
          _self.target.dropdown_sort.attr('disabled', false);
        }
      }

      _self.target.dropdown_sort.each(function()
      {
        if ( $(this).is(':checked') )
        {
          _self.config.order_by += $(this).val() + ',';
        }
      });

      _self.config.order_by = _self.config.order_by.replace(/,\s*$/, "");
      _self.paged           = 1;

      _self.make_ajax_request();
    });
  }

  /**
   * Init dropdown taxonomy inputs
   * 
   */
  init_dropdown_terms()
  {
    let _self = this;

    this.target.dropdown_taxonomy.on('change', function( e )
    {
      // Keep dropdown open
      $(this).closest( '.dropdown-menu' ).addClass('show');
      $(this).closest( '.dropdown' ).addClass('show');

      if ( $(this).is(':checked') )
      {
        _self.add_term( $(this) );

        _self.show_reset();
      }
      else
      {
        _self.remove_term( $(this) );
      }
    });
  }

  /**
   * Init dropdown post types
   * 
   */
  init_dropdown_types()
  {
    let _self = this;

    this.target.dropdown_content_type.on('change', function( e )
    {
      // Keep dropdown open
      $(this).closest( '.dropdown-menu' ).addClass('show');
      $(this).closest( '.dropdown' ).addClass('show');

      if ( $(this).is(':checked') )
      {
        _self.config.post_types.push( $(this).val() );

        _self.show_reset();
      }
      else
      {
        _self.config.post_types = _self.config.post_types.filter( ( e ) => {
          return e !== $(this).val();
        });
      }

      _self.config.paged = 1;

      _self.make_ajax_request();
    });
  }

  /**
   * Init pagination
   * 
   */
  init_pagination()
  {
    let _self = this;

    $('body').on('click', this.component_id + ' .c-pagination a.page-numbers', function( e )
    {
      e.preventDefault();

      // Get current page num
      let current = parseInt( $(this).parent().find('span.current').html() );

      // Get page num
      _self.config.paged = $(this).html();

      if ( $(this).hasClass('prev') )
      {
        _self.config.paged = current - 1;
      }
      else if ( $(this).hasClass('next') )
      {
        _self.config.paged = current + 1;
      }

      _self.update_state();
      _self.make_ajax_request( false ); 
    });
  }

  /**
   * Init search input
   *
   */
  init_search()
  {
    let _self = this;

    this.target.search.on( 'keyup input', this.debounce( function()
    {
      _self.config.search_term = $(this).val().trim();
      _self.config.paged       = 1;

      if ( _self.config.search_term != '' )
      {
        $(this).parent().parent().addClass('active');
        _self.target.result_text.html( _self.config.search_term );
      } 
      else
      {
        $(this).parent().parent().removeClass('active');
        _self.target.result_text.html('');
      }

      _self.make_ajax_request();
    }, 150 ) );
  }

  /**
   * Init display toggle for grid/list view
   * 
   */
  init_view_toggle()
  {
    let _self = this;

    this.target.view_toggle.on('click', function( e )
    {
      e.preventDefault();

      if ( ! $(this).hasClass('active') )
      {
        _self.target.view_toggle.addClass('active').not(this).removeClass('active');

        _self.config.view = $(this).attr('data-toggle-view');

        _self.make_ajax_request(); 
      }
    });
  }

  /**
   * Add term
   *
   * @param jQuery el
   */
  add_term( el )
  {
    let _self    = this,
        taxonomy = el.attr('data-taxonomy'),
        term     = el.attr('data-term'),
        label    = el.val(),
        chip     = '<a href="#" class="chip filter active has-close mr-4" data-taxonomy="' + taxonomy + '" data-term="' + term + '">' + label + '</a>';

    // If taxonomy key does not exist yet, add it
    if ( ! ( taxonomy in _self.config.terms ) )
    {
      _self.config.terms[taxonomy] = [];
    }

    // If terms is not in the stack, add it
    if ( _self.config.terms[taxonomy].includes( term ) === false )
    {
      // If term added is the same as topic chips taxonomy, disable "All" chip
      if ( _self.config.chips_taxonomy == taxonomy )
      {
        $(this.component_id + ' a.chip.all').removeClass('active');
      }

      // If we're dynamically adding chips
      if ( _self.config.add_chip_on_active )
      {
        $(this.component_id + ' .c-chips').append( chip );
      }

      _self.config.terms[taxonomy].push( term );
      _self.config.paged = 1;

      _self.show_reset();
      _self.make_ajax_request();
    }
  }

  /**
   * Add terms
   *
   * @param jQuery el
   */
  add_terms( el )
  {
    let _self    = this;
    el.each(function() {
      let tax = $( this )[0].getAttribute("data-taxonomy");
      let term = $( this )[0].getAttribute("data-term");
      if ( ! ( tax in _self.config.terms ) )
      {
        _self.config.terms[tax] = [];
      }
      _self.config.terms[tax].push( term );
    });

    _self.config.paged = 1;

    _self.show_reset();
    _self.make_ajax_request();
  }

  /**
   * Remove term
   *
   * @param jQuery el
   */
  remove_term( el )
  {
    let _self    = this,
        taxonomy = el.attr('data-taxonomy'),
        term     = el.attr('data-term');

    // Uncheck selection
    this.target.dropdown_taxonomy.filter( function()
    {
      return ( $(this).attr('data-taxonomy') == taxonomy && $(this).attr('data-term') == term );
    }).prop('checked', false);

    // Remove taxonomy term
    _self.config.terms[taxonomy] = _self.config.terms[taxonomy].filter( function ( e )
    {
      return e !== term;
    });

    // Remove taxonomy if empty
    for ( let key in _self.config.terms )
    {
      if ( _self.config.terms[key].length === 0 )
      {
        delete _self.config.terms[key];
      }
    }

    // Set "All" to active if no terms are selected
    if ( $.isEmptyObject( _self.config.terms ) || ! ( _self.config.chips_taxonomy in _self.config.terms ) )
    {
      $(_self.component_id + ' a.chip.all').addClass('active');
    }

    // Remove chip
    if ( _self.config.remove_chip_on_deactivate )
    {
      $(this.component_id + ' a.chip').filter( function()
      {
        return ( $(this).attr('data-taxonomy') == taxonomy && $(this).attr('data-term') == term );
      }).remove();
    }

    _self.config.paged = 1;

    _self.make_ajax_request();
  }

  /**
   * Show reset
   * 
   */
  show_reset()
  {
    $(this.component_id + ' .filter--reset').addClass('active');
  }

  /**
   * Update current and total counts
   * 
   */
  update_count()
  {
    let current = window.count_current;

    if ( window.count_total == 0 )
    {
      current = 0;
    }

    else if ( window.count_current < window.count_total )
    {
      current = ( this.config.paged == 1 ) ? window.count_current : ( window.count_current - ( this.config.items_per_page - 1 ) ) + '-' + window.count_current;
    }

    // Set last page count
    else if ( window.count_current == window.count_total )
    {
      if ( window.count_current == 0 )
      {
        current = 0;
      }
      else
      {
        // 9 % 9 = 0
        // 
        let remainder = window.count_total % this.config.items_per_page ;

        if ( remainder == 0 )
        {
          current = window.count_total + '-' + window.count_total;
        }
        else
        {
          current = ( window.count_total - remainder + 1 ) + '-' + window.count_total;
        }
      }
    }
    
    $(this.component_id + ' span.count-current').html( current );
    $(this.component_id + ' span.count-total').html( window.count_total );
  }

  /**
   * Update history state
   *
   * @param bool is_default_state
   */
  update_state( is_default_state = false )
  {
    let _self = this;

    if ( is_default_state )
    {
      window.history.replaceState( null, null, this.config.url );
    }
    else
    {
      let url = this.config.url;
      let joiner = '?';

      // Add page number
      if ( this.config.paged > 1 )
      {
        url += '/page/' + this.config.paged;
      }

      // Add chips terms
      if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms[_self.config.chips_taxonomy] )
      {
        url += joiner + 'terms=' + _self.config.terms[_self.config.chips_taxonomy].join(',');
        joiner = '&';
      }

      // Add additional url parameters for certain ajax actions
      let $deeplink_actions = [
        'sysdig_v4_filter__resource_cards',
        'sysdig_v4_filter__blog_cards',
        'sysdig_v4_filter__integration_cards',
        'sysdig_v4_filter__partner_cards',
        'sysdig_v4_filter__open_positions_cards',
        'sysdig_v4_filter__webinar_cards',
        'sysdig_v4_filter__customer_cards',
        'sysdig_v4_filter__learn_cloud_cards'
      ]
      if ($deeplink_actions.includes(_self.config.action)) {
        // Add product terms
        if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms['sd-tax-filter-product'] )
        {
          url += joiner + 'products=' + _self.config.terms['sd-tax-filter-product'].join(',');
          joiner = '&';
        }

        // Add environment terms
        if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms['sd-tax-filter-orchestrator'] )
        {
          url += joiner + 'environments=' + _self.config.terms['sd-tax-filter-orchestrator'].join(',');
          joiner = '&';
        }

        // Add platform terms
        if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms['sd-tax-filter-platform'] )
        {
          url += joiner + 'platforms=' + _self.config.terms['sd-tax-filter-platform'].join(',');
          joiner = '&';
        }
        
        // Add partner location terms
        if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms['sd-tax-filter-partner-location'] )
        {
          url += joiner + 'locations=' + _self.config.terms['sd-tax-filter-partner-location'].join(',');
          joiner = '&';
        }

        // Add job location terms
        if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms['job_location'] )
        {
          url += joiner + 'locations=' + _self.config.terms['job_location'].join(',');
          joiner = '&';
        }

        // Add region terms
        if ( ! $.isEmptyObject( _self.config.terms ) &&
          _self.config.terms['sd-tax-filter-region'] )
        {
          url += joiner + 'region=' + _self.config.terms['sd-tax-filter-region'].join(',');
          joiner = '&';
        }

        // Add post types
        if ( ! $.isEmptyObject( _self.config.post_types ) &&
          _self.config.action != 'sysdig_v4_filter__customer_cards' )
        {
          url += joiner + 'types=' + _self.config.post_types.join(',');
          joiner = '&';
        }

        // Add search
        if ( ! $.isEmptyObject( _self.config.search_term ) )
        {
          url += joiner + 'search=' + _self.config.search_term;
          joiner = '&';
        }
      }

      window.history.replaceState( null, null, url );
    }
  }

  /**
   * Update External go.sysdig.com links
   *
   */
  update_external_links() {
    this.pathfactoryLinkUTMs = new PathFactoryLinkUTMs;

    this.pathfactoryLinkUTMs.init();
  }

  /**
   * Make ajax request
   *
   * @param bool is_reset
   */
  make_ajax_request( is_reset = false )
  {
    let _self = this;

    this.back_to_top();
    this.update_state();
    
    let data = {
      action:     this.config.action,
      author_id:  this.config.author_id,
      link_field: this.config.link_field,
      order_by:   this.config.order_by,
      paged:      this.config.paged,
      post_types: this.config.post_types,
      per_row:    this.config.items_per_row,
      search:     this.config.search_term,
      terms:      this.config.terms,
      url:        this.config.url,
      view:       this.config.view,
      is_reset:   is_reset
    };

    /**
     * Default request
     */
    if ( ! _self.config.is_webinar )
    {
      $.ajax({
        type:   'POST',
        url:    sysdigLocalizedObject.ajaxUrl,
        data:   data,
        success: function( resp )
        {
          _self.target.target_container.html( resp );
          _self.update_count();
          _self.update_external_links();

          if ( _self.callback != '' && _self.callback !== undefined )
          {
            _self.callback();
          }
        }
      });
    }

    /**
     * Multiple requests for Webinar
     * 
     */
    else
    {
      if ( _self.config.paged == 1 )
      {
        data.type = 'upcoming';

        // Upcoming
        $.ajax({
          type:   'POST',
          url:    sysdigLocalizedObject.ajaxUrl,
          data:   data,
          success: function( resp )
          {
            _self.target.webinar_upcoming.parent().removeClass('hidden');
            _self.target.webinar_upcoming.html( resp );

            _self.update_count();
            // _self.update_external_links();

            if ( window.webinar_upcoming_is_empty && window.webinar_upcoming_is_empty === true )
            {
              _self.target.webinar_upcoming.parent().addClass('hidden');
            }
          }
        });
      }
      else
      {
        _self.target.webinar_upcoming.parent().addClass('hidden');
      }

      data.type = 'on_demand';

      // On-Demand
      $.ajax({
        type:   'POST',
        url:    sysdigLocalizedObject.ajaxUrl,
        data:   data,
        success: function( resp )
        {
          _self.target.webinar_on_demand.html( resp );
          _self.update_count();
          // _self.update_external_links();
        }
      });
    }
  }

  /**
   * Reset
   * 
   */
  reset()
  {
    this.target.chips.removeClass('active')
    this.target.chips_all.addClass('active');
    this.target.search.val('');
    this.target.dropdown_sort.prop('checked', false);
    this.target.dropdown_taxonomy.prop('checked', false);
    this.target.dropdown_content_type.prop('checked', false);
    this.target.reset.removeClass('active');
    this.target.view_toggle.removeClass('active').filter(function()
    {
      return $(this).attr('data-toggle-view') == 'grid';
    }).addClass('active')

    this.config = structuredClone( this.default_config );
  
    this.config.terms = {};
    this.config.search_term = '';

    this.make_ajax_request( true );
  }
}
